module.exports = __webpack_public_path__ + "static/media/badge-2-yellow-big.aaa56a4e.svg";